// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_StarRating.scss
// module id = 665
// module chunks = 61 88